class ReviewStars extends HTMLElement {
  constructor() {
    super();

    this.badgeElement = this.querySelector(".jdgm-prev-badge");
    if (
      this.badgeElement &&
      !this.badgeElement.querySelector(".js-review-summary")
    ) {
      const score = this.badgeElement.getAttribute("data-average-rating");
      const count = this.badgeElement.getAttribute("data-number-of-reviews");

      const newText = document.createElement("span");
      newText.classList.add("js-review-summary");
      newText.innerHTML = `<strong>${score}</strong> (${count})`;

      this.badgeElement.appendChild(newText);
    }
  }
}

customElements.define("review-stars", ReviewStars);
